import React from "react";
import { useSite } from "../contexts/SiteContext";

const CERT_IMG = "/images/certificate.jpg";

const Testimonial = () => {
  const { content } = useSite();
  const t = content.testimonial || {};
  return (
    <section style={{ padding: "90px 24px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto", background: "#14103F", borderRadius: 32, padding: "56px 56px", display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 40, alignItems: "center", overflow: "hidden", position: "relative" }} className="testi-grid fade-in">
        <div>
          <span className="pill pill-dark" style={{ marginBottom: 16 }}>
            <span style={{ width: 18, height: 1, background: "#fff", opacity: 0.6 }} /> {t.kicker}
          </span>
          <h2 className="h-display" style={{ fontSize: "clamp(28px, 3.8vw, 50px)", color: "#fff", margin: "12px 0 18px", lineHeight: 1.05 }}>
            &ldquo;<span className="text-grad-purple-light">{t.quote}</span>&rdquo;
          </h2>
          <p style={{ color: "rgba(255,255,255,0.65)", fontSize: 15, lineHeight: 1.6, maxWidth: 460 }}>{t.subtitle}</p>
        </div>
        <div style={{ position: "relative" }}>
          <div className="img-zoom-wrap card-soft" style={{ borderRadius: 24, aspectRatio: "4/5" }}>
            <img src={CERT_IMG} alt="Certificado" className="img-zoom" />
          </div>
          <div className="chip-card" style={{ position: "absolute", bottom: -18, left: -18, maxWidth: 240 }}>
            <span style={{ width: 30, height: 30, borderRadius: 8, background: "rgba(255,79,26,0.15)", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#FF4F1A", fontWeight: 800, fontSize: 14 }}>★</span>
            <div style={{ lineHeight: 1.25 }}>
              <div style={{ fontSize: 13 }}>{t.chipTitle}</div>
              <div style={{ fontSize: 11, color: "#5F5A72", fontWeight: 500 }}>{t.chipSubtitle}</div>
            </div>
          </div>
        </div>
      </div>
      <style>{`@media (max-width: 900px){.testi-grid{grid-template-columns:1fr !important;padding:32px !important;}}`}</style>
    </section>
  );
};

export default Testimonial;
